import { hex2Rgb, rgb2Hex } from './hex2rgb.function'

const HEX_COLOR = /^#[0-9a-f]{6}$/i
const MIN_CONTRAST_ON_WHITE_TEXT = 4.5
const DARK_INK = '#2d2e32'

function isValidBrandColor(value) {
  return HEX_COLOR.test(`${value || ''}`.trim())
}

function normalizeBrandColor(value) {
  const hex = `${value === null || typeof value === 'undefined' ? '' : value}`.trim()
  if (!hex) return ''
  return isValidBrandColor(hex) ? hex.toLowerCase() : ''
}

function channelLuminance(channel) {
  const v = channel / 255
  return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
}

function relativeLuminance(value) {
  const rgb = hex2Rgb(normalizeBrandColor(value))
  if (!rgb) return null
  return 0.2126 * channelLuminance(rgb.r) + 0.7152 * channelLuminance(rgb.g) + 0.0722 * channelLuminance(rgb.b)
}

function contrastWithWhite(value) {
  const luminance = relativeLuminance(value)
  if (luminance === null) return null
  return Math.round((1.05 / (luminance + 0.05)) * 100) / 100
}

function carriesWhiteText(value) {
  const contrast = contrastWithWhite(value)
  return contrast === null ? false : contrast >= MIN_CONTRAST_ON_WHITE_TEXT
}

function contrastBetween(a, b) {
  const la = relativeLuminance(a)
  const lb = relativeLuminance(b)
  if (la === null || lb === null) return null
  const hi = Math.max(la, lb)
  const lo = Math.min(la, lb)
  return Math.round(((hi + 0.05) / (lo + 0.05)) * 100) / 100
}

function readableTextOn(background) {
  const hex = normalizeBrandColor(background)
  if (!hex) return ''

  const onWhite = contrastWithWhite(hex)
  const onInk = contrastBetween(hex, DARK_INK)
  if (Math.max(onWhite, onInk) >= MIN_CONTRAST_ON_WHITE_TEXT) return onWhite >= onInk ? '#ffffff' : DARK_INK

  return onWhite >= contrastBetween(hex, '#000000') ? '#ffffff' : '#000000'
}

function darkenBrandColor(value, amount = 0.18) {
  const rgb = hex2Rgb(normalizeBrandColor(value))
  if (!rgb) return ''

  const scale = channel => Math.max(0, Math.min(255, Math.round(channel * (1 - amount))))

  return rgb2Hex(scale(rgb.r), scale(rgb.g), scale(rgb.b))
}

function nearestReadableColor(value) {
  let hex = normalizeBrandColor(value)
  if (!hex) return ''

  for (let step = 0; step < 24 && !carriesWhiteText(hex); step += 1) hex = darkenBrandColor(hex, 0.06)

  return carriesWhiteText(hex) ? hex : '#000000'
}

export {
  isValidBrandColor,
  contrastBetween,
  readableTextOn,
  DARK_INK,
  normalizeBrandColor,
  relativeLuminance,
  contrastWithWhite,
  carriesWhiteText,
  darkenBrandColor,
  nearestReadableColor,
  MIN_CONTRAST_ON_WHITE_TEXT,
}
